import styled from 'styled-components';

const MAIN_COLOR = 'white';

const SiteContent = styled.div`
    background-color: ${MAIN_COLOR};
    margin: 0 auto;
    min-height: 100vh;
    width: 100%;
    position: relative;
    overflow: hidden;
`;

export default SiteContent;
